<div class="avc-card">
  <div class="avc-card__media">
    <img [src]="vehicleImage" [alt]="vehicleName" class="avc-card__img" />
    <span class="avc-card__badge" *ngIf="vehicleId">
      <ion-icon name="pricetag-outline"></ion-icon>
      {{ vehicleId }}
    </span>
  </div>

  <div class="avc-card__body">
    <h2 class="avc-card__title">{{ vehicleName }}</h2>

    <button type="button" class="avc-card__btn">
      View Details
      <ion-icon name="arrow-forward-outline"></ion-icon>
    </button>
  </div>
</div>